<template>
   <div class="table-responsive mb-0">
      <table class="table table-centered table-nowrap text-center">
         <thead class="thead-light">
            <tr>
               <th></th>
               <th>Ene.</th>
               <th>Feb.</th>
               <th>Mar.</th>
               <th>Abr.</th>
               <th>May.</th>
               <th>Jun.</th>
               <th>Jul.</th>
               <th>Ago.</th>
               <th>Sep.</th>
               <th>Oct.</th>
               <th>Nov.</th>
               <th>Dic.</th>
               <th>Total</th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td class="text-body font-weight-bold">Objetivos</td>
               <td v-for="(item, index) in objetivos" :key="index">{{ item | currency }}</td>
            </tr>
            <tr>
               <td class="text-body font-weight-bold">{{ year }}</td>
               <td v-for="(item, index) in actual" :key="index">{{ item | currency }}</td>
            </tr>
            <tr>
               <td class="text-body font-weight-bold">{{ year - 1 }}</td>
               <td v-for="(item, index) in anterior" :key="index">{{ item | currency }}</td>
            </tr>
         </tbody>
      </table>
   </div>
</template>

<script>
   export default {
      props: {
         data: {
            type: Object,
            default: function() {
            return [];
            }
         }
      },
      computed: {
         year() {
            return new Date().getFullYear()
         },
         objetivos () {
            var obj = this.data.obj
            var total = parseFloat(obj.ene) + parseFloat(obj.feb) + parseFloat(obj.mar) + parseFloat(obj.abr) + parseFloat(obj.may) + parseFloat(obj.jun) + parseFloat(obj.jul) + parseFloat(obj.ago) + parseFloat(obj.sep) + parseFloat(obj.oct) + parseFloat(obj.nov) + parseFloat(obj.dic)
            return [obj.ene, obj.feb, obj.mar, obj.abr, obj.may, obj.jun, obj.jul, obj.ago, obj.sep, obj.oct, obj.nov, obj.dic, total]
         },
         actual () {
            var obj = this.data.act
            var total = parseFloat(obj.ene) + parseFloat(obj.feb) + parseFloat(obj.mar) + parseFloat(obj.abr) + parseFloat(obj.may) + parseFloat(obj.jun) + parseFloat(obj.jul) + parseFloat(obj.ago) + parseFloat(obj.sep) + parseFloat(obj.oct) + parseFloat(obj.nov) + parseFloat(obj.dic)
            return [obj.ene, obj.feb, obj.mar, obj.abr, obj.may, obj.jun, obj.jul, obj.ago, obj.sep, obj.oct, obj.nov, obj.dic, total]
         },
         anterior () {
            var obj = this.data.ant
            var total = parseFloat(obj.ene) + parseFloat(obj.feb) + parseFloat(obj.mar) + parseFloat(obj.abr) + parseFloat(obj.may) + parseFloat(obj.jun) + parseFloat(obj.jul) + parseFloat(obj.ago) + parseFloat(obj.sep) + parseFloat(obj.oct) + parseFloat(obj.nov) + parseFloat(obj.dic)
            return [obj.ene, obj.feb, obj.mar, obj.abr, obj.may, obj.jun, obj.jul, obj.ago, obj.sep, obj.oct, obj.nov, obj.dic, total]
         }
      }
   };
</script>